/* Copyright Levelise Ltd 2019 - 2026 */
import React, { Component } from 'react';

const UserContext = React.createContext({
	user: {},
	username: '',
	error: null,
	setUser: () => {},
	setUsername: () => {},
	clearUser: () => {},
	setError: () => {},
	clearError: () => {},
});

export default UserContext;

export class UserProvider extends Component {
	state = {
		user: {},
		username: '',
		error: null,
	};

	setError = (error) => this.setState({ error });
	clearError = () => this.setState({ error: null });
	setUser = (user) => this.setState({ user });
	setUsername = (username) => this.setState({ username });

	clearUser = () => {
		this.setState({
			user: {},
			username: '',
			error: null,
		});
	};

	render() {
		const contextValue = {
			user: this.state.user,
			error: this.state.error,
            username: this.state.username,
			setUser: this.setUser,
			clearUser: this.clearUser,
			setError: this.setError,
			clearError: this.clearError,
            setUsername: this.setUsername,
		};
		return <UserContext.Provider value={contextValue}>{this.props.children}</UserContext.Provider>;
	}
}
